<template>
  <div class="auth">
    <div class="auth-logo">
      <img src="@/assets/2-1.png">
    </div>
    <div class="auth-container">
      <div class="auth-wrapper">
        <p class="auth-title">Forgot Password</p>
        <primary-input type="email"
                       name="email"
                       v-model="email"
                       v-validate="'required|email'"
                       :class="{'email-input': true, 'is-danger': errors.has('email')}"
                       placeholder="elyse_sauer@yahoo.com" />
        <div v-if="errors.has('email')"
             class="help is-danger">
          {{ errors.first('email') }}
        </div>
        <div class="help is-danger"
             v-if="error">
          {{error}}
        </div>
        <button @click="forgotPassword"
                class="primary-button">Check</button>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  components: {
    PrimaryInput: () => import('../../components/Inputs/PrimaryInput.vue')
  },
  data: () => ({
    email: '',
    error: null
  }),
  methods: {
    forgotPassword() {
      this.$validator.validate().then(result => {
        if(result) {
          this.$store.dispatch('forgotPassword', this.email).then(() => {
            this.$snotify.success("Confirmation email was sent.", {
              timeout: 6000,
            });
            this.$router.push({path: '/login'});
          }).catch(() => {
            this.error = "Email not found";
            setTimeout(() => {
               this.error = null
              }, 6000);
          })
        }
      })
    }
  }
}
</script>

<style lang="scss" scoped>
.auth {
  display: flex;
  flex-direction: column;
  align-items: center;
  width: 100%;
  height: 100%;
  .auth-logo {
    margin-top: 45px;
    margin-bottom: 75px;
  }
  .auth-container {
    width: 100%;
    height: 100%;
    display: flex;
    align-items: center;
    justify-content: center;
    .auth-wrapper {
      display: flex;
      flex-direction: column;
      align-items: center;
      width: 420px;
      border-radius: 4px;
      background-color: #ffffff;
      box-shadow: 0 1px 2px 0 rgba(0, 0, 0, 0.05);
      padding: 60px;
      .auth-title {
        color: #000000;
        font-family: ""Helvetica Neue"";
        font-size: 24px;
        font-weight: bold;
        line-height: 24px;
        text-align: center;
        margin-bottom: 30px;
      }
      .email-input {
        margin-bottom: 20px;
      }
      button {
        align-self: flex-start;
        width: 90px;
        height: 40px;
      }
    }
  }
}
</style>

